import { InjectionToken } from '@angular/core';

import { CommonDialogConfig } from '@plugins/client/dialog/types';

export const COMMON_TOAST_CONFIG = new InjectionToken<CommonDialogConfig>(
  'commonToastConfig',
);
